import { render } from "./Brief_episodes.vue?vue&type=template&id=a91f2566"
import script from "./Brief_episodes.vue?vue&type=script&lang=js"
export * from "./Brief_episodes.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__